<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_4"></a>This is a work of fiction. All the characters and events portrayed in this novel are either fictitious or are used fictitiously.</p>
<p class="copyright1"><span class="small">SUN OF SUNS: VIRGA, BOOK ONE</span></p>
<p class="copyright1">Copyright © 2006 by Karl Schroeder</p>
<p class="copyright1">All rights reserved, including the right to reproduce this book, or portions thereof, in any form.</p>
<p class="copyright1">Edited by David G. Hartwell</p>
<p class="copyright1">A Tor Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="copyright1"><span class="weblink"><a class="nounder" href="http://www.tot.com" target="_blank">www.tor.com</a></span></p>
<p class="copyright1">Tor<sup>®</sup> is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright1">Schroeder, Karl, 1962–<br/>    Sun of suns / Karl Schroeder.—1st ed.<br/>         p. cm. — (Virga ; bk. 1)<br/>    “A Tom Doherty Associates book.”<br/>ISBN-13: 978-0-765-31543-4<br/>ISBN-10: 0-765-31543-2<br/>I. Title<br/>PR9199.3.S269S86  2006<br/>813'.6—dc22                                                                  2006005929</p>
<p class="copyright1">First Edition: October 2006</p>
<p class="copyright1">Printed in the United States of America</p>
<p class="copyright1">0   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?5b5b0d76